import React, {Component} from 'react';
import {ErrorMessage, Field, Form, Formik} from "formik";
import {Redirect} from "react-router";
import {withTranslation} from 'react-i18next';
import Header from "../Parts/Header";
import SubHeader from "../Parts/SubHeader";
import {toast} from "react-toastify";

class IncomeFamily extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                phone: '',
                email: '',
            },
            step_count: 3,
            current_step: 3,

            email_sent: false,
            sms_sent: false,

            redirectToNextStep: false,
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    renderForm(props) {
        return (
            <Form className="form form-layout mt-5">
                <div className="container form-layout__2-col justify-content-start">
                    <div className="col-12 mb-3">{this.props.t('choose_spouse_link_sending_method')}</div>

                    <div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="phone">{this.props.t('forms.spouse_phone')}</label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <div className="input-group-text">+370</div>
                            </div>
                            <Field type="text"
                                   name="phone"
                                   id="phone"
                                   className={'form-control' + (props.errors.phone && props.touched.phone ? ' is-invalid' : '')}
                                   autoFocus
                            />
                        </div>
                        <ErrorMessage name="phone" component="div" className="invalid-feedback definitely-show"/>
                    </div>

                    <div className="form-group col-md-6 col-lg-6">
                        <label className="form-label" htmlFor="email">{this.props.t('forms.spouse_email')}</label>
                        <Field type="text" name="email" id="email"
                               autoComplete="email"
                               className={'form-control' + (props.errors.email && props.touched.email ? ' is-invalid' : '')}/>
                        <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12 d-flex justify-content-center mt-3">
                        <button type="submit" className="btn btn-primary btn-lg" disabled={props.isSubmitting}>
                            {this.props.t('forms.next')}
                        </button>
                    </div>
                </div>
            </Form>);
    }

    formSubmit(values, actions) {
        axios.post('/api/process/' + this.props.application_token + '/send_spouse_link', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    if (data.data.sms_sent || data.data.email_sent) {
                        this.setState({
                            sms_sent: data.data.sms_sent,
                            email_sent: data.data.email_sent,
                            current_step: this.state.current_step + 1,
                        });
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                    actions.setStatus({message: response_data.message})
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    checkSpouseConsent() {
        axios.get('/api/process/' + this.props.application_token + '/check_consent', {params: {client_type: 'S'}})
            .then(
                data => {
                    if (data.data.data.has_consent) {
                        this.setState({redirectToNextStep: true});
                    } else {
                        toast.info(
                            this.props.t('spouse_consent_not_signed_yet')
                            ,{toastId: 'waiting_for_spouse_consent'}
                        );
                    }

                },
                error => {
                    let response_data = error.response.data;
                    toast.error(response_data.message);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={this.props.suggestion.process_step_urls.choose_terms}/>
        }

        return (
            <div>
                <Header title={this.props.t('step.registration')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.send_spouse_link')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>

                        {!this.state.sms_sent && !this.state.email_sent &&
                        <div className="row">
                            <Formik
                                initialValues={this.state.data}
                                onSubmit={this.formSubmit}
                                render={this.renderForm}
                            />
                        </div>
                        }

                        {(this.state.sms_sent || this.state.email_sent) &&
                        <div className="container py-5">
                            <div className="col-12 d-flex justify-content-center">
                                <span className="success-icon"><i className="icons icon-check"></i></span>
                            </div>
                            <div className="col-12 d-flex justify-content-center mt-4">
                                <p className="heading--2">{this.props.t('dear_customer')}</p>
                            </div>
                            <div className="col-12 mt-2">
                                <p>{this.props.t('forms.spouse_consent_link_sent')}</p>
                            </div>
                            <div className="col-12 d-flex justify-content-center mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg"
                                    onClick={() => this.checkSpouseConsent()}
                                >
                                    {this.props.t('forms.continue_btn')}
                                </button>
                            </div>
                        </div>

                        }

                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(IncomeFamily);
